export default "__VITE_ASSET__DWe1gvUT__"